// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "segment-3BUo3";
var _3 = "stopPointInfoMessage-qnL65";
var _4 = "stopPointInfoMessage__htmlMessage-1MxFE";
var _5 = "canceled-28Ma9";
var _6 = "segment_additional-3il9j";
var _7 = "oneSegment-295-y";
var _8 = "flightInfo-UgjDn";
var _9 = "flightInfo__containerAirline-2c83Y";
var _a = "flightInfo__date-1faz2";
var _b = "flightInfo__airline-3-QbF";
var _c = "flightInfo__singleFlight-3bKg7";
var _d = "flightInfo__icon-3uIk2";
var _e = "flightInfo__container-2hKpb";
var _f = "route__plane-1sfq4";
var _10 = "flightInfo__nextDay-Piukx";
var _11 = "route-gdANG";
var _12 = "planeContainer-1mJOP";
var _13 = "amenities-1m-tW";
var _14 = "plane-3bqCD";
var _15 = "plane_return-3LTvC";
var _16 = "planeInfo-2PGTA";
var _17 = "aircraft-20Jok";
var _18 = "route__time-3OjoV";
var _19 = "totalDuration__decorator-2-9Pd";
var _1a = "segment__technicalStops-1xxlF";
var _1b = "operatingCarrier-28GNu";
export { _1 as "__esModule", _2 as "segment", _3 as "stopPointInfoMessage", _4 as "stopPointInfoMessage__htmlMessage", _5 as "canceled", _6 as "segment_additional", _7 as "oneSegment", _8 as "flightInfo", _9 as "flightInfo__containerAirline", _a as "flightInfo__date", _b as "flightInfo__airline", _c as "flightInfo__singleFlight", _d as "flightInfo__icon", _e as "flightInfo__container", _f as "route__plane", _10 as "flightInfo__nextDay", _11 as "route", _12 as "planeContainer", _13 as "amenities", _14 as "plane", _15 as "plane_return", _16 as "planeInfo", _17 as "aircraft", _18 as "route__time", _19 as "totalDuration__decorator", _1a as "segment__technicalStops", _1b as "operatingCarrier" }
export default { "__esModule": _1, "segment": _2, "stopPointInfoMessage": _3, "stopPointInfoMessage__htmlMessage": _4, "canceled": _5, "segment_additional": _6, "oneSegment": _7, "flightInfo": _8, "flightInfo__containerAirline": _9, "flightInfo__date": _a, "flightInfo__airline": _b, "flightInfo__singleFlight": _c, "flightInfo__icon": _d, "flightInfo__container": _e, "route__plane": _f, "flightInfo__nextDay": _10, "route": _11, "planeContainer": _12, "amenities": _13, "plane": _14, "plane_return": _15, "planeInfo": _16, "aircraft": _17, "route__time": _18, "totalDuration__decorator": _19, "segment__technicalStops": _1a, "operatingCarrier": _1b }
